/**
 * 流程实例命名：与后端 resolveNameTemplate 对齐
 * 支持 {a.b}，并兼容历史脏数据 {{a.b}}
 */

function getByPath(obj, path) {
  if (obj == null || !path) return undefined;
  const parts = String(path).split('.').filter(Boolean);
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    if (Array.isArray(cur)) {
      cur = cur.map((item) =>
        (item != null && typeof item === 'object') ? item[p] : undefined);
      continue;
    }
    cur = cur[p];
  }
  return cur;
}

function formatTemplateValue(v) {
  if (v == null) return '';
  if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') {
    return String(v);
  }
  if (Array.isArray(v)) {
    return v.map((item) => formatTemplateValue(item)).filter(Boolean).join('、');
  }
  if (typeof v === 'object') {
    return v.name || v.label || v.title || v.key || v.id || '';
  }
  return String(v);
}

export function normalizeNameRule(tpl) {
  let s = String(tpl == null ? '' : tpl);
  s = s.replace(/\{\{([^{}]+)\}\}/g, '{$1}');
  s = s.replace(/\{\{([^{}]+)\}/g, '{$1}');
  return s;
}

/** 默认命名：YYYYMMDDHHmmss + 3位随机数 */
export function buildTimestampRandomName(date = new Date()) {
  const pad = (n, len = 2) => String(n).padStart(len, '0');
  const d = date instanceof Date ? date : new Date();
  const stamp =
    `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}` +
    `${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
  const rand = Math.floor(Math.random() * 1000);
  return `${stamp}${pad(rand, 3)}`;
}

/** 按命名规则从 formData 生成实例名 */
export function resolveNameTemplate(tpl, formData) {
  const rule = normalizeNameRule(tpl).trim();
  if (!rule) return '';
  return rule.replace(/\{([^{}]+)\}/g, (_, rawPath) => {
    const path = String(rawPath || '').trim();
    if (!path) return '';
    return formatTemplateValue(getByPath(formData, path));
  }).trim();
}
